import React, {PureComponent} from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Chip,
  Tooltip
} from "@material-ui/core";


class UserInfoDialog extends PureComponent{
  constructor(props){
    super(props)
  }

  openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  } 

  render(){
      const { user, open, onClose } = this.props;
      const {
        proTags = [],
        proInstagram = "",
        proDNI = "",
        proName = "",
        proEmail = "",
        proLastName = "",
        proPhone = "",
      } = user;
      return (
        <Dialog
          maxWidth={"xl"}
          fullWidth={true}
          open={open}
        >
          <DialogTitle>Informacion del Usuario</DialogTitle>
          <DialogContent>
            <Table
              stickyHeader
              style={{
                minWidth: 500,
                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.23)",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Nombre
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Apellido
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Instagram
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Telefono
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Email
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Documento
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Tags
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{proName}</TableCell>
                  <TableCell>{proLastName}</TableCell>
                  <TableCell>
                    <Button
                      style={{ backgroundColor: "aquamarine" }}
                      onClick={() =>
                        this.openInNewTab(`https://instagram.com/${proInstagram}`)
                      }
                    >
                      {proInstagram}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      style={{ backgroundColor: "aquamarine" }}
                      onClick={() =>
                        this.openInNewTab(
                          `https://api.whatsapp.com/send/?phone=549${proPhone}`
                        )
                      }
                    >
                      {proPhone}
                    </Button>
                  </TableCell>
                  <TableCell>{proEmail}</TableCell>
                  <TableCell>{proDNI}</TableCell>
                  <TableCell>
                    {proTags.map((t) => (
                      <Chip
                        label={t.tagName}
                        style={{ backgroundColor: t.tagColor }}
                      />
                    ))}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Aceptar">
              <Button
                variant="contained"
                color="secondary"
                onClick={onClose}
              >
                Aceptar
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      );
    }
  
}

export default UserInfoDialog


// WEBPACK FOOTER //
// ./src/components/Dialog/UserInfoDialog.js